import React from 'react'
import classnames from 'classnames'

import Link from '../components/Link'
import AnimatedNumber from '../components/AnimatedNumber'

function AnimatedMetrics ({ items, onTopOfDarkBg, extraClass }) {
  const textClasses = classnames(
    {
      'text-para--light': onTopOfDarkBg,
      'text-para--dark': !onTopOfDarkBg
    },
    'text-para small mb2'
  )
  const linkClasses = classnames(
    {
      white: onTopOfDarkBg
    },
    'strong'
  )
  return (
    <ul className={classnames(extraClass, 'animated-metrics col-10 mx-auto')}>
      {items &&
        items.map(
          ({ metricPrefix, metric, metricSuffix, text, reference }, idx) => (
            <li key={idx} className='animated-metrics__list-item col-10 mb4'>
              <h1 className='animated-metrics__title h2 pb2 mb3'>
                {metricPrefix}
                <AnimatedNumber
                  className='huge'
                  finalNumber={parseFloat(metric)}
                />
                {metricSuffix}
              </h1>
              <p className={textClasses}>{text}</p>
              {reference.url && (
                <Link
                  className={linkClasses}
                  href={reference.url}
                  target='_blank'
                >
                  {reference.label}
                </Link>
              )}
              {!reference.url && <p className='bold'>{reference.label}</p>}
            </li>
          )
        )}
    </ul>
  )
}

export default AnimatedMetrics



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/AnimatedMetrics.js